import AdminUserList from "../../admin/user-list/UserList";

const UserList = () => {
  return <AdminUserList isEmployeeUserList={true} />;
}

export default UserList;